export var ERequestStatus = /*#__PURE__*/function (ERequestStatus) {
  ERequestStatus[ERequestStatus["Init"] = 0] = "Init";
  ERequestStatus[ERequestStatus["Pending"] = 1] = "Pending";
  ERequestStatus[ERequestStatus["Complete"] = 2] = "Complete";
  return ERequestStatus;
}({});